export const SUBSCRIPTION_FEATURES = {
  YEARLY_SUBSCRIPTION: 'yearly-subscription',
  MONTHLY_SUBSCRIPTION: 'monthly-subscription',
  SUBSCRIPTION_INITIAL_FEE: 'subscription-initial-fee',
};
